<template>
	<section class="form_body clear_fix">

		<div class="wg_left_column ready_analyzes_wrap">

			<div class="analyze_box">
				<p class="analyze_name">Название анализа</p>
				<p class="analyze_date">07.04.2017</p>
			</div>

			<div class="analyze_box">
				<p class="analyze_name">Название анализа</p>
				<p class="analyze_date">07.04.2017</p>
			</div>

			<div class="analyze_box">
				<p class="analyze_name">Название анализа</p>
				<p class="analyze_date">07.04.2017</p>
			</div>
		</div>

		<div class="box_field">
			<form @submit.prevent="sendForm(data)">

				<div class="field_row" v-for="field in form.fields">

					<div v-if="field.type != 'textarea'" class="field_name">{{field.label}}</div>

					<label>
						<input v-model="data[field.label]" v-if="field.type == 'text'" :name="field.uniname" type="text"
									 class="field_item field_item_text">
					</label>

					<label>
						<input v-model="data[field.label]" v-if="field.type == 'number'" :name="field.uniname" type="number"
									 class="field_item field_item_number">
					</label>

					<div v-if="field.type == 'checkbox'" class="checkbox_wrap">

						<label>
							<input v-model="data[field.label]" type="checkbox" class="field_item field_item_checkbox">
						</label>

					</div>

					<textarea title="description" v-model="data[field.label]" v-if="field.type == 'textarea'"
										:placeholder="field.label" class="field_item field_item_textarea"></textarea>

					<div v-show="field.type !='textarea'" class="field_last_name">{{field.si}}</div>
				</div>

				<div class="field_row bort">
					<textarea placeholder="Комментарий" class="field_item field_item_textarea" cols="30" rows="10"
										v-model="data['Комментарий']"></textarea>
				</div>

				<div class="form_viewer_select_file clear_fix">
					<div class="field_row">
						<div class="field_name">Прикрепить файл</div>
						<input type="file" @change="getDocument" class="type_file">
						<div class="field_last_name"></div>
					</div>

					<input type="submit" value="Сохранить" class="saveButton"/>
				</div>

			</form>
		</div>
	</section>
</template>

<script>
	import _ from 'underscore'

	export default {
		name: 'FormViewer',
		props: ["form", 'type'],
		computed: {
			patientId() {
				return this.$route.query.patient
			},
			doctorId() {
				return this.$route.query.doctor
			}
		},
		data() {
			return {
				data: {},
				reqObject: {},
				fileContainer: ''
			}
		},
		methods: {
			sendForm(data) {
				_(data).map((item, i) => {
					this.reqObject[i] = item
				})

				this.reqObject.formName = this.form.name
				this.reqObject.type = this.type
				this.reqObject.worker_id = this.doctorId
				this.reqObject.user_id = this.patientId

				this.$store.dispatch('card/create', this.reqObject).then(() => {
					if(this.fileContainer)
						this.fileContainer.target.value = ''

					this.data = {}
					this.reqObject = {}

					return this.$store.dispatch('card/getByType', {
						type: this.type,
						worker_id: this.doctorId,
						user_id: this.patientId
					})
				}).then(() => {
					this.$event.send(this.type)
					this.openTab(2)
				})
			},
			getDocument(e) {
				if(e.target.files.length) {
					this.reqObject.file = e.target.files[0]
					this.fileContainer = e
				}
			},
			openTab(number) {
				$('.tabs-bar li').removeClass('active')
				$('.patient-card-info>div').removeClass('active')
				$('.patient-card-info>div[class=block-' + number + ']').addClass('active')
			}
		}
	}
</script>

<style>

	.type_file {
		width: 200px;
	}

	.saveButton {
		margin-top: 20px;
		margin-right: 10px;
		padding: 5px 10px;
		font-size: 0.9em;
		background: #295596;
		border: none;
		border-radius: 0; /*was 4*/
		float: right;
		color: #fff;
	}

	.form_body {
		background-color: #FFF;
	}

	.form_viewer_select_file {
		padding-bottom: 20px;
	}

</style>



// WEBPACK FOOTER //
// FormViewer.vue?d8e716e8